import __request__ from "routing/request";
export function multipleMetricsAllNodes(Requestedmetrics) {
  return __request__("POST", "/cluster/metrics/multiple", Requestedmetrics, {}, {
    "Accept": ["application/json"]
  });
}
